import { render, staticRenderFns } from "./CaptureVideoMobile.vue?vue&type=template&id=3e348438"
import script from "./CaptureVideoMobile.vue?vue&type=script&lang=js"
export * from "./CaptureVideoMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports